export enum FormationCategory {
  FPRBQ = 'fprbq',
  ASP = 'asp', 
  OTHER = 'other'
}

export interface AcqRegion {
  name: string
  code: string
}

export interface FormationType {
    crm_id: string,
    training_id: string,
    start_date?: null | string,
    end_date ?: null | string,
    title: string,
    type :  string,
    category: string,
    participant_full_name?: null | string,
    moodle_link: string,
    duration?: null | string,
    price?: null | string | number,
    acq_region?: null | AcqRegion
  }

  export interface Schedule {
    date: string,
    start_time: string,
    end_time: string
  }

  export interface FormationDetailsType {
    address?: null | string,
    postal_code?: null | string,
    city?: null | string,
    schedule: null | [Schedule],
    type?: string | null,
    acq_region?: AcqRegion | null
  }

  export interface FormationOtherDatesType {
    cohort: string | null
    id: string,
    start_date: string
    end_date: string
    title: string
    address?: string | null
    schedule?: null | [Schedule],
    type?: string,
    price?: null | string | number,
    acq_region?: null | AcqRegion
  }

  export interface UpdateInscriptionDate {
    old_training_id: string
    new_training_id: string
  }
  